import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/class-credits-report',
};

export const getColumns = () => [
  {
    id: 'facilityName',
    label: 'Studio',
    align: 'left',
    nameForSort: 'facility_name',
  },
  {
    id: 'region',
    label: 'Region',
    align: 'center',
    disableSort: true,
  },
  {
    id: 'totalClasses',
    label: 'Total Classes',
    align: 'center',
    nameForSort: 'total_classes',
  },
  {
    id: 'totalCredits',
    label: 'Total Credits',
    align: 'center',
    nameForSort: 'total_credits',
  },
  {
    id: 'bonusCredits',
    label: 'Bonus Credits',
    align: 'center',
    nameForSort: 'bonus_credits',
  },
  {
    id: 'creditValue',
    label: 'Credit Value',
    align: 'center',
    nameForSort: 'credit_value',
  },
  {
    id: 'classCostValue',
    label: 'Class Cost Value',
    align: 'center',
    nameForSort: 'class_cost_value',
  },
];

export const getFilters = ({ region, searchByFacilityName, dateRange, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Studio name...',
    action: searchByFacilityName.change,
  },
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
